import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords don't match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password updated.");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed — request a new link");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#F9F9F8] flex items-center justify-center p-8">
      <div className="w-full max-w-sm space-y-6">
        <Link to="/" className="flex items-center gap-2" data-testid="reset-brand-link">
          <div className="w-4 h-4 bg-[#E54D2E]" />
          <span className="font-display font-bold">Runwell HQ</span>
        </Link>

        {!token ? (
          <div>
            <h1 className="font-display text-3xl font-bold">Invalid reset link</h1>
            <p className="text-sm text-neutral-600 mt-2">This link is missing its token. Request a new one from the sign-in page.</p>
            <Link to="/login"><Button className="mt-6 bg-neutral-900 text-white rounded-sm" data-testid="reset-back-login-btn">Back to sign in</Button></Link>
          </div>
        ) : done ? (
          <div data-testid="reset-success">
            <h1 className="font-display text-3xl font-bold">Password updated.</h1>
            <p className="text-sm text-neutral-600 mt-2">Redirecting you to sign in…</p>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <div className="mono text-xs tracking-widest uppercase text-neutral-500">RESET PASSWORD</div>
              <h1 className="font-display text-3xl font-bold mt-2">Choose a new password.</h1>
            </div>
            <div className="space-y-2">
              <Label htmlFor="pw">New password</Label>
              <Input id="pw" type="password" required minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)} className="rounded-sm" data-testid="reset-password-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="pw2">Confirm password</Label>
              <Input id="pw2" type="password" required minLength={6} value={confirm} onChange={(e)=>setConfirm(e.target.value)} className="rounded-sm" data-testid="reset-confirm-input" />
            </div>
            <Button type="submit" disabled={busy} className="w-full bg-neutral-900 hover:bg-neutral-800 text-white rounded-sm btn-lift" data-testid="reset-submit-btn">
              {busy ? "Updating…" : "Update password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
